/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoiceTransactionStatus = {
    InvoiceTransactionStatusPending: 'pending',
    InvoiceTransactionStatusProcessing: 'processing',
    InvoiceTransactionStatusSucceeded: 'succeeded',
    InvoiceTransactionStatusFailed: 'failed',
    InvoiceTransactionStatusCanceled: 'canceled'
} as const;
export type InvoiceTransactionStatus = typeof InvoiceTransactionStatus[keyof typeof InvoiceTransactionStatus];


// @ts-ignore
export function InvoiceTransactionStatusFromJSON(json: any): InvoiceTransactionStatus {
    return InvoiceTransactionStatusFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceTransactionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceTransactionStatus {
    return json as InvoiceTransactionStatus;
}

// @ts-ignore
export function InvoiceTransactionStatusToJSON(value?: InvoiceTransactionStatus | null): any {
    return value as any;
}

